import React, { useState } from 'react';
import getConfig, { Env } from '../../config';
import { ChevronDown } from '../../icons';
import {
  ModalContainer,
  SelectPolicyModal,
  ModalHeader,
  StyledText,
  StyledDivHoldingPolicy,
  StyledPolicyText,
  ChevronDiv,
  FullDropdown,
  PolicySelector,
  StyledDropdownText,
  DropdownOptions,
  Content,
  StyledButtonHolder,
  StyledCancelButton,
  StyledContinueButton,
  Backdrop
} from './PolicyDropdownStyles';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';

const config = getConfig(process.env.REACT_APP_ENV as Env);

export interface ClaimsSelectAPolicyDropdownProps {
  modalInformation: any;
  code: any;
  closeModal: Function;
}

export default ({
  modalInformation,
  code,
  closeModal
}: ClaimsSelectAPolicyDropdownProps) => {
  const [policy, setPolicy] = useState('');
  const [openDropdown, setOpenDropdown] = useState(false);
  let index = 0;

  const CloseDropdownModal = () => {
    closeModal();
  };

  const FindPolicy = () => {
    for (let i = 0; i < modalInformation.length; i++) {
      if (
        policy.includes(
          modalInformation[i].policy_type +
            '...' +
            modalInformation[i].policy_number.slice(-4)
        )
      ) {
        index = i;
      }
    }
  };

  const StartNewClaim = () => {
    simpleGTMDataLayer({
      event: 'claimsSelectPolicyDropdown',
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: 'Redirect to Claims'
    });
    closeModal();
    FindPolicy();
    window.open(
      config.start_a_new_claim +
        modalInformation[index].policy_number +
        code[index] +
        '&utm_source=SA360&utm_medium=internal&utm_campaign=SA360'
    );
  };

  if (modalInformation && modalInformation[0]?.policy_type !== undefined) {
    if (policy === '') {
      setPolicy(
        modalInformation[0].policy_type +
          '...' +
          modalInformation[0].policy_number.slice(-4)
      );
    }
    return (
      <Backdrop>
        <ModalContainer>
          <SelectPolicyModal>
            <ModalHeader>Select a Policy</ModalHeader>
            <StyledText>
              Before starting a new claim, please let us know which policy this
              claim is being filed against.
            </StyledText>
            <StyledDivHoldingPolicy>
              <StyledPolicyText>Policy</StyledPolicyText>
            </StyledDivHoldingPolicy>
            <ChevronDiv>
              <ChevronDown />
            </ChevronDiv>
            <FullDropdown>
              <PolicySelector
                onClick={() => {
                  setOpenDropdown(!openDropdown);
                }}
              >
                <StyledDropdownText>{policy}</StyledDropdownText>
              </PolicySelector>
              {openDropdown && (
                <DropdownOptions>
                  {modalInformation.map((info: any) => {
                    return (
                      <Content
                        onClick={() => {
                          setPolicy(
                            info.policy_type +
                              '...' +
                              info.policy_number.slice(-4)
                          );
                          setOpenDropdown(false);
                        }}
                      >
                        <StyledDropdownText>
                          {info.policy_type +
                            '...' +
                            info.policy_number.slice(-4)}
                        </StyledDropdownText>
                      </Content>
                    );
                  })}
                </DropdownOptions>
              )}
            </FullDropdown>
            <StyledButtonHolder>
              <StyledCancelButton onClick={CloseDropdownModal}>
                CANCEL
              </StyledCancelButton>
              <StyledContinueButton onClick={StartNewClaim}>
                CONTINUE
              </StyledContinueButton>
            </StyledButtonHolder>
          </SelectPolicyModal>
        </ModalContainer>
      </Backdrop>
    );
  }
  return <div />;
};
